module.exports = __webpack_public_path__ + "img/ch23_03_力量汇聚.8dcaf0fd.jpg";